import React from 'react';

const AdminPanel = () => {
  return (
    <div>
      <h2>Admin Control Panel</h2>
      <p>This is the administration interface for Rent Ready Bids system management.</p>
    </div>
  );
};

export default AdminPanel; 